/** S3 Bucketからのダウンロード失敗 */
export const FETCH_GET_ERROR_CODE = 'fetch_01'
/** S3 Bucketへのアップロード失敗 */
export const FETCH_PUT_ERROR_CODE = 'fetch_02'
